import { render, staticRenderFns } from "./scientific-fib.vue?vue&type=template&id=7f5de7ee&scoped=true"
import script from "./scientific-fib.ts?vue&type=script&lang=ts&external"
export * from "./scientific-fib.ts?vue&type=script&lang=ts&external"
import style0 from "./scientific-fib.scss?vue&type=style&index=0&id=7f5de7ee&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5de7ee",
  null
  
)

export default component.exports